import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { convertStraight, convertThenFormat } from "../../common-data/Converts";
import Loader from "../../ui/Loader";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const LeaveCardAccordian = ({
  isLeadLoading,
  rowData,
  handleDelete,
  isStaff,
  setModValues,
}) => {
  const isDisbaled =
    rowData?.leave_dates_with_status?.length > 0
      ? rowData.leave_dates_with_status.every(
          (leave) => leave?.approval_status === 2
        )
      : false;

  const isDisbaledCancelBtn =
    rowData?.leave_dates_with_status?.length > 0
      ? rowData.leave_dates_with_status.some((leave) => {
          const leaveDate = new Date(leave.leave_date);
          const today = new Date();
          return leave?.approval_status === 1 && leaveDate < today;
        })
      : false;

  return (
    <div className="all-followuo-info-container">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className="heade-info">
              <span className="title">Approval Action</span>
              <span className="value">
                {rowData?.is_action_pending === "true" ? (
                  <CrossCircleIcon color="#FFF" />
                ) : (
                  <CheckCircleIcon color="#FFF" />
                )}
              </span>
            </div>
            {/* <div className="heade-info">
              <span className="title">Leave Applied On</span>
              <span className="value">
                {rowData?.apply_date
                  ? convertStraight(rowData.apply_date)
                  : "-"}
              </span>
            </div> */}
          </Accordion.Header>

          <Accordion.Body>
            <div className="lead-multi-value-cols px20px pb20px">
              {/* <div className="label-value">
                <span className="label">Leave Applied On</span>
                <span className="value">
                  {rowData?.apply_date
                    ? convertStraight(rowData.apply_date)
                    : "-"}
                </span>
              </div> */}

              {/* {!isStaff ? (
                <div className="label-value">
                  <span className="label">Staff Designation</span>
                  <span className="value">{rowData?.account_type || "NA"}</span>
                </div>
              ) : null} */}

              {!isStaff ? (
                <div className="label-value">
                  <span className="label">Staff Salary</span>
                  <span className="value">
                    {" "}
                    ₹{convertThenFormat(rowData?.salary || 0)}
                  </span>
                </div>
              ) : null}

              <div className="label-value">
                <span className="label">Deducted Amount</span>
                <span className="value">
                  ₹{convertThenFormat(rowData?.deducted_salary || 0)}
                </span>
              </div>

              <div className="label-value">
                <span className="label">Taken/Total Leaves This Year</span>
                <span className="value">
                  {" "}
                  {rowData?.total_leave_days_used || 0}/
                  {rowData?.yearly_leave || 0}
                </span>
              </div>

              <div className="label-value">
                <span className="label">Remaining Leaves</span>
                <span className="value">
                  {rowData?.total_leave_days_remaining || "0"}
                </span>
              </div>

              {!isStaff ? (
                <div className="label-value">
                  <span className="label">Approved Leaves</span>
                  <span className="value">
                    {rowData?.total_leave_days_approved || 0}
                  </span>
                </div>
              ) : null}

              {!isStaff ? (
                <div className="label-value">
                  <span className="label">Rejected Leaves</span>
                  <span className="value">
                    {rowData?.total_leave_days_rejected || 0}
                  </span>
                </div>
              ) : null}

              <div className="label-value">
                <span className="label">Leave Paid</span>
                <span className="value">
                  {rowData?.is_paid ? <CheckCircleIcon /> : <CrossCircleIcon />}
                </span>
              </div>

              <div className="label-value">
                <span className="label">doc required</span>
                <span className="value">
                  {rowData?.doc_required ? (
                    <CheckCircleIcon />
                  ) : (
                    <CrossCircleIcon />
                  )}
                </span>
              </div>

              <div className="label-value">
                <span className="label">approval required</span>
                <span className="value">
                  {rowData?.approval_required ? (
                    <CheckCircleIcon />
                  ) : (
                    <CrossCircleIcon />
                  )}
                </span>
              </div>

              <div className="label-value">
                <span className="label">Days Before</span>
                <span className="value">{rowData?.days_before || 0}</span>
              </div>

              <>
                {/* <div className="label-value">
                  <span className="label">Approval Complete</span>
                  <span className="value">
                    {" "}
                    {rowData?.is_action_pending ? (
                      <CrossCircleIcon />
                    ) : (
                       <CheckCircleIcon />
                    )}
                  </span>
                </div> */}
              </>

              <div className="label-value flex-col">
                <span className="label">description</span>
                <span className="value">{rowData?.description || "NA"}</span>
              </div>
            </div>

            <div className="all-btns lead-btn-axceed">
              <div className="lead-log-box">
                <button
                  className="lead-log download"
                  disabled={!rowData?.required_doc}
                  style={{
                    cursor: rowData?.required_doc ? "pointer" : "not-allowed",
                  }}
                >
                  <a href={rowData?.required_doc}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-cloud-arrow-down"
                      viewBox="0 0 16 16"
                      style={{
                        color: rowData?.required_doc ? "#379C00" : "gray",
                        width: "35px",
                        height: "35px",
                      }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                      />
                      <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                    </svg>
                  </a>
                </button>

                <span className="btn-label">Download</span>
              </div>

              <div className="lead-log-box">
                <button
                  className="lead-log view"
                  onClick={(e) =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      leaveDetails:
                        rowData?.leave_dates_with_status?.length > 0
                          ? rowData.leave_dates_with_status
                          : [],
                      cardType: "view",
                      rowData: rowData,
                    }))
                  }
                  style={{
                    // border:
                    //   rowData?.leave_dates_with_status?.length > 0
                    //     ? "1px solid #bc0909"
                    //     : "1px solid #9C9C9C",
                    // color:
                    //   rowData?.leave_dates_with_status?.length > 0
                    //     ? "#bc0909"
                    //     : "#9C9C9C",
                    // borderRadius: "12px",
                    cursor:
                      rowData?.leave_dates_with_status?.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                  disabled={rowData?.leave_dates_with_status?.length === 0}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrows-angle-expand"
                    viewBox="0 0 16 16"
                    style={{
                      color:
                        rowData?.leave_dates_with_status?.length > 0
                          ? "#171717"
                          : "#9C9C9C",
                      width: "20px",
                      height: "20px",
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
                    />
                  </svg>
                </button>

                <span className="btn-label">View</span>
              </div>

              {isStaff ? (
                <div className="lead-log-box">
                  <button
                    className="lead-log edit-btn"
                    style={{
                      color: isDisbaled ? "gray" : "#FFF",
                      // background: isDisbaled ? "lightgray" : "#379C00",
                      cursor: isDisbaled ? "not-allowed" : "pointer",
                    }}
                    onClick={() =>
                      !isDisbaled
                        ? setModValues((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            cardType: "edit",
                            rowData: rowData,
                          }))
                        : null
                    }
                    disabled={isDisbaled}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-pencil"
                      viewBox="0 0 16 16"
                      style={{
                        color: !isDisbaled ? "#000" : "gray",
                        width: "30px",
                        height: "30px",
                      }}
                    >
                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                    </svg>
                  </button>

                  <span className="btn-label">Edit</span>
                </div>
              ) : null}

              {(!isDisbaled || !isDisbaledCancelBtn) && isStaff ? (
                <div className="lead-log-box">
                  <button
                    className="lead-log delete-btn"
                    style={{
                      color:
                        isDisbaled || isDisbaledCancelBtn ? "gray" : "#FFF",
                      background:
                        isDisbaled || isDisbaledCancelBtn ? "" : "#F13434",
                      cursor:
                        isDisbaled || isDisbaledCancelBtn
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onClick={() => {
                      const uidFilter = {
                        user_id: rowData?.user_id || "",
                        apply_date: rowData?.apply_date || "",
                        leave_category_id: rowData?.leave_category_id || "",
                      };
                      handleDelete(uidFilter);
                    }}
                    disabled={isDisbaled || isDisbaledCancelBtn}
                  >
                    {isLeadLoading ? (
                      <Loader />
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-x-lg"
                        viewBox="0 0 16 16"
                        style={{
                          color:
                            isDisbaled || isDisbaledCancelBtn ? "gray" : "#FFF",
                          width: "30px",
                          height: "30px",
                        }}
                      >
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                      </svg>
                    )}
                  </button>

                  <span className="btn-label">Cancel</span>
                </div>
              ) : null}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default LeaveCardAccordian;
